import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import CredentialCardSet from '@nmx/template/dist/componentLibrary/modules/CredentialCardSet';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <SectionContainer
    id='podcast-credential-callout-grouping'
    moduleName='credentials-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col align='center'>
        <Typography
          align='center'
          component='h2'
          nextElement='typography'>
          Your financial strength, powered <WidowBlock>by ours.</WidowBlock>
        </Typography>
        <Typography
          nextElement='graphic'>
          For over 165 years, we&#39;ve been committed to helping our clients succeed. And we&#39;re good at it.
        </Typography>
      </Col>
    </Row>
    <CredentialCardSet
      accentColorVariant='gold'
      accentOrientation='vertical'
      backgroundVariant='lightA'
      credentials={[
        {
          credential: 'rankedInvestmentService',
          sup1: 1,
        },
        {
          credential: 'financialStrengthRating',
          sup1: 2,
        },
        {
          credential: 'numberOfClients',
          sup1: 3,
        },
      ]}
      hasAccent
      themeType='lightTheme'
    />
  </SectionContainer>
);
